var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareMail = function SvgShareMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.875 23.594h-8.75c-3.194 0-5.031-1.838-5.031-5.032v-6.125c0-3.193 1.837-5.03 5.031-5.03h8.75c3.194 0 5.031 1.837 5.031 5.03v6.126c0 3.193-1.837 5.03-5.031 5.03m-8.75-14.875c-2.502 0-3.719 1.216-3.719 3.719v6.124c0 2.503 1.217 3.72 3.719 3.72h8.75c2.503 0 3.719-1.217 3.719-3.72v-6.125c0-2.502-1.216-3.718-3.719-3.718z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.5 16.261c-.736 0-1.48-.227-2.048-.691l-2.739-2.187a.654.654 0 0 1 .814-1.024l2.739 2.187c.665.534 1.793.534 2.458 0l2.74-2.187c.28-.228.7-.184.918.105.227.28.184.7-.105.918l-2.739 2.188c-.56.464-1.304.691-2.039.691"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.6,
    height: 29.6,
    x: 0.7,
    y: 0.7,
    stroke: "#000",
    strokeWidth: 1.4,
    rx: 3.3
  })));
};
export default SvgShareMail;